import { DropZone } from '../models/dropzone.model';
import { DropZoneNamedPosition } from '../models/dropzonenamedposition.model';
import { BaseService } from './base.service';

class DropZoneService extends BaseService{ 
    /*
    async getDropZoneData(): Promise<DropZone> {
        return new Promise<DropZone>(async (ok, fail) => {
            const API_URL = '/api/dropzone';
            try {
              const response = await fetch(API_URL);          
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
        
              const data: DropZone = await response.json();
              ok(data);
            } catch (error) {
              console.error('Error : ', error);
              fail(error);
            }
        }); 
    }*/

    async getDropZoneNamedPositions(): Promise<DropZoneNamedPosition[]> {        
      const headers = this.getHeaders();
      const API_URL = '/api/dropzone-named-positions';
      try {
          const response = await fetch(API_URL, {headers: headers});          
          if (!response.ok) {
            throw new Error(`HTTP status : ${response.status}`);
          }
  
          const data: DropZoneNamedPosition[] = await response.json();
          return data;
      } catch (error) {
          console.error('Error : ', error);
          throw error;
      } 
  }

    async getDropZoneData(): Promise<DropZone> {        
        const headers = this.getHeaders();
        const API_URL = '/api/dropzone';
        try {
            const response = await fetch(API_URL, {headers: headers});          
            if (!response.ok) {
              throw new Error(`HTTP status : ${response.status}`);
            }
    
            const data: DropZone = await response.json();
            return data;
        } catch (error) {
            console.error('Error : ', error);
            throw error;
        } 
    }

    async saveData(dzData:DropZone): Promise<DropZone> {        
      const headers = this.getHeaders();
      const API_URL = '/api/dropzone';
      try {
          const response = await fetch(API_URL,  
                              {
                              method:"POST", 
                              body: JSON.stringify(dzData), 
                              headers: headers
                              });

          if (!response.ok) {
            throw new Error(`HTTP status: ${response.status}`);
          }
  
          const data: DropZone = await response.json();
          return data;
      } catch (error) {
          console.error('Error : ', error);
          throw error;
      } 
  }
}

export default new DropZoneService();